const Footer = () => {
  const curYear = new Date().getFullYear();

  return (
    <div className="footer">
      <div>(주)아미소프트 &nbsp;&nbsp; Amiesoft Corporation</div>
      <div className="mt-2">
        <small>서울시 강남구 강남대로 94길 67 도연빌딩 7층</small>
      </div>
      <div className="mt-2">
        <small>7F, Doyeon Bldg., 67, Gangnam-daero 94-gil, Gangnam-gu, Seoul, Republic of Korea</small>
      </div>
      <div className="mt-2">
        <small>📞 : 02-554-5131 / 📠 : 02-554-5132</small>
      </div>
      <div className="mt-4">© {curYear} Amiesoft All Rights Reserved.</div>
    </div>
  );
};

export default Footer;
